import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function Model(props) {
  const handleClose = () => props.setShow(false);
  return (
    <>
      <Modal show={props.show} onHide={handleClose}>
        <Modal.Header  closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body  className='d-flex flex-column gap-3' >
          <p>{props.description}</p>
          <div>
            <h6>{props.email}</h6>
            <h6>{props.password}</h6>
          </div>
          <div >
            <h5>Note:</h5>
            <p>{props.note}</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
